export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["AML перевірка"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Введіть адресу та оберіть блокчейн — виконаємо швидкий скринінг."])}
}